import React, { useState, useEffect } from 'react';
import { Col, Row, Checkbox } from 'antd';
import ConsultarAlimentosIcon from '../assets/iconConsultarAlimentos.png';
import { useParams } from 'react-router-dom';
import InputAdornment from '@mui/material/InputAdornment';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import TextField from "@mui/material/TextField";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import {
    ArrowLeftOutlined,
    QuestionCircleOutlined
} from '@ant-design/icons';
import './ConsultarAlimentosDesc.scss';
import { useNavigate } from 'react-router-dom'
import { createRefInDay, getAlimentosByGrupoId } from '../service/api';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};

const ConsultarAlimentosDesc = () => {
    let navigate = useNavigate();
    const [foodList, setFoodList] = useState([])
    const [checkedItems, setCheckedItems] = useState([])
    const [openFooter, setOpenFooter] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [openModalDoubt, setOpenModalDoubt] = useState(false)
    const [inputText, setInputText] = useState("");
    const [lastItemSelected, setLastItemSelected] = useState({})
    const [inputTextModal, setInputTextModal] = useState("");
    const [checkedItemsToSend, setCheckedItemsToSend] = useState([])
    const [viewDescription, setViewDescription] = useState(false);
    const [medidaCaseira, setMedidaCaseira] = useState("")
    const [quantidademedida, setQuantidademedida] = useState("")
    const [open, setOpen] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    let { categorie } = useParams();
    let { catname } = useParams();
    let { day } = useParams();
    let { ref } = useParams();
    let { recipeId } = useParams();

    useEffect(() => {
        const loadAlimentos = async () => {
            await getAlimentosByGrupoId(categorie)
                .then(response => {
                    setFoodList(response)
                })
                .catch(function (error) {
                    console.log(error)
                });
        }
        loadAlimentos()
    }, []);

    const onClickBack = () => {
        if (day)
            navigate(`/consultar-alimentos/${day}/${ref}`, { replace: true });
        else if (recipeId)
            navigate(`/consultar-alimentos/${recipeId}`, { replace: true });
        else
            navigate('/consultar-alimentos', { replace: true });

    }

    const onChange = (checkedValues) => {
        var list = checkedItems
        var listToSend = checkedItemsToSend
        if (list.includes(checkedValues.nome)) {
            const index = list.indexOf(checkedValues.nome);
            list.splice(index, 1);
            listToSend.splice(index, 1);
        } else {
            setLastItemSelected(checkedValues)
            handleOpen()
        }
        setCheckedItems(list)
        setCheckedItemsToSend(listToSend)
        if (list.length > 0)
            setOpenFooter(true)
        else
            setOpenFooter(false)
    };

    const openDesc = (checkedValues) => {
        setLastItemSelected(checkedValues)
        handleOpen()
    };

    const registrarQuantidade = (item, value, medidaValue) => {
        if (value != "" && medidaValue != "") {
            setErrorMessage("Preencha apenas um dos campos")
            setOpen(true)
        } else if (value != "" || medidaValue != "") {
            var gramasConsumidas
            if (value != "") {
                gramasConsumidas = value
            } else {
                gramasConsumidas = medidaValue
            }
            var list = checkedItems
            var listToSend = checkedItemsToSend
            list.push(item.nome)
            item.consumido = gramasConsumidas
            listToSend.push(item)
            setCheckedItems(list)
            setCheckedItemsToSend(listToSend)
            handleClose()
            if (list.length > 0)
                setOpenFooter(true)
            else
                setOpenFooter(false)
        } else {
            setOpen(true)
            setErrorMessage("Informe a quantidade consumida do alimento")
        }
    }

    const registrarAlimentos = async () => {
        if(recipeId){
            const recipe = JSON.parse(localStorage.getItem(recipeId))
            var resp = recipe
            console.log(recipe)
            let alimentos = []
            checkedItemsToSend.map(function (item, i) {
                const obj = {
                    alimentoid: item.alimentoid,
                    quantidade: item.consumido,
                    nome: item.nome
                }
                alimentos.push(obj)
            })
            resp.alimentos = resp.alimentos.concat(alimentos)
            localStorage.setItem(recipeId, JSON.stringify(resp))
            navigate(`/calcular-receitas/${recipeId}`, { replace: true });
        }else{
            const date = new Date
            var userId = localStorage.getItem("userId");
            const dayonWeeks = {
                'dom': 0,
                'seg': 1,
                'ter': 2,
                'qua': 3,
                'qui': 4,
                'sex': 5,
                'sab': 6
            }
            let dateSelected = (date.getDate() - date.getDay()) + dayonWeeks[day];
            dateSelected = new Date(date.setDate(dateSelected)).toISOString();
            let alimentos = []
            checkedItemsToSend.map(function (item, i) {
                const obj = {
                    alimentoid: item.alimentoid,
                    quantidade: item.consumido
                }
                alimentos.push(obj)
            })
            await createRefInDay(alimentos, dateSelected, userId, ref)
                .then(response => {
                    if (response) {
                        navigate('/diario', { replace: true });
                    }
                }).catch(error => {
    
                })
    
            //navigate('/diario', { replace: true });
        }
    }

    let inputHandlerModal = (e) => {
        //convert input text to lower case
        var lowerCase = e.target.value.toLowerCase();
        var text = lowerCase.replace(',','.')
        setInputTextModal(lowerCase);
    };

    let inputHandlerMedidaCaseira = (e) => {
        //convert input text to lower case
        var lowerCase = e.target.value.toLowerCase();
        var consumido
        if (medidaCaseira == lastItemSelected.medidaCaseira) {
            consumido = parseFloat(lowerCase) * parseFloat(lastItemSelected.pesomedidacaseira)
        } else if (medidaCaseira == lastItemSelected.medidaCaseira2) {
            consumido = parseFloat(lowerCase) * parseFloat(lastItemSelected.pesomedidacaseira)
        } else {
            consumido = parseFloat(lowerCase) * parseFloat(lastItemSelected.pesomedidacaseira)
        }
        setQuantidademedida(consumido);
    };

    const handleOpen = () => {
        setOpenModal(true)
        setMedidaCaseira("")
        setInputTextModal("")
    };
    const handleClose = () => setOpenModal(false);

    const handleOpenDoubt = () => setOpenModalDoubt(true);
    const handleCloseDoubt = () => setOpenModalDoubt(false);

    const handleChange = (event) => {
        setMedidaCaseira(event.target.value)
    };

    const checkHasMedidaCaseira = (item) => {
        if (item) {
            if ((item.medidaCaseira != "" && item.medidaCaseira != "ND") || (item.medidaCaseira2 != "" && item.medidaCaseira2 != "ND") || (item.medidaCaseira3 != "" && item.medidaCaseira3 != "ND")) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    return (
        <div className='consultar'>
            <Row>
                <Col span={24} className='consultar__header'>
                    <ArrowLeftOutlined className='consultar__icons' onClick={onClickBack} />
                    <img src={ConsultarAlimentosIcon} alt='' className='consultar__logo' />
                    <p className='consultar__title'>Consultar Alimentos</p>
                </Col>
            </Row>

            <p className='consultar__titleCat'>{catname}</p>
            <hr className="consultar__solid" />

            <p className='consultar__teorProteina'>Teor de Proteína</p>
            <div className='consultar__tabela'>
                <div style={{ height: 15, width: 15, backgroundColor: 'red', marginTop: 13, marginRight: 5, borderRadius: 10 }} />
                <p style={{ marginRight: 15 }}>Alto</p>
                <div style={{ height: 15, width: 15, backgroundColor: 'orange', marginTop: 13, marginRight: 5, borderRadius: 10 }} />
                <p style={{ marginRight: 15 }}>Médio</p>
                <div style={{ height: 15, width: 15, backgroundColor: 'green', marginTop: 13, marginRight: 5, borderRadius: 10 }} />
                <p style={{ marginRight: 15 }}>Baixo</p>
                <div style={{ marginTop: -17, marginLeft: -30, color: '#0000EE' }}>
                    <QuestionCircleOutlined onClick={handleOpenDoubt} />
                </div>
            </div>

            <div>
                {
                    foodList.map(function (item, i) {
                        return (
                            <Checkbox.Group style={{ width: '100%' }}>
                                <div key={i} className="consultar__grid-item" onClick={() => (!day || recipeId) && openDesc(item)}>
                                    {
                                        (day || recipeId) &&
                                        <Checkbox value={item.nome} style={{ paddingLeft: 10, paddingRight: 5 }} onChange={() => onChange(item)} />
                                    }
                                    <div style={{ width: 250, marginLeft: 5, color: '#555555' }}>
                                        {
                                            item.nome.length > 40 ?
                                                item.nome.substr(0, 40) + " ..."
                                                :
                                                item.nome
                                        }
                                    </div>
                                    {
                                        item.name == "Gorduras e azeites" || parseFloat(item.proteina.replace(',', '.')) <= 0.5 ?
                                            <div style={{ height: 15, width: 15, backgroundColor: 'green', marginTop: 3, marginLeft: 5, borderRadius: 10 }} />
                                            : parseFloat(item.proteina.replace(',', '.')) > 0.5 && parseFloat(item.proteina.replace(',', '.')) < 1.2 ?
                                                <div style={{ height: 15, width: 15, backgroundColor: 'orange', marginTop: 3, marginLeft: 5, borderRadius: 10 }} />
                                                : parseFloat(item.proteina.replace(',', '.')) > 1.2 ?
                                                    <div style={{ height: 15, width: 15, backgroundColor: 'red', marginTop: 3, marginLeft: 5, borderRadius: 10 }} />
                                                    :
                                                    ""
                                    }
                                </div>
                            </Checkbox.Group>
                        )
                    })
                }
            </div>

            {
                openFooter && (day || recipeId) &&
                <div class="consultar__footer" onClick={registrarAlimentos}>
                    <p>Inserir Alimentos</p>
                </div>
            }
            <Snackbar open={open} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
            </Snackbar>
            <Modal
                open={openModal}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className="consultar__modalNutrientes">
                        <div className="consultar__modal" style={{ fontSize: 13 }}>
                            Porção de 100g
                        </div>
                        <div className="consultar__modal">
                            <b>Alimento:</b> {lastItemSelected.nome}
                        </div>
                        {lastItemSelected.proteina != "ND" &&
                            <div className="consultar__modal">
                                <b>Proteína:</b> {lastItemSelected.proteina}g
                            </div>
                        }
                        {lastItemSelected.carboidrato != "ND" &&
                            <div className="consultar__modal">
                                <b>Carboidrato:</b> {lastItemSelected.carboidrato}g
                            </div>
                        }
                        {lastItemSelected.energia != "ND" &&
                            <div className="consultar__modal">
                                <b>Valor Enegético:</b> {lastItemSelected.energia}kcal
                            </div>
                        }
                        {lastItemSelected.lipidios != "ND" &&
                            <div className="consultar__modal">
                                <b>Lipídios:</b> {lastItemSelected.lipidios}mg
                            </div>
                        }
                        {lastItemSelected.calcio != "ND" &&
                            <div className="consultar__modal">
                                <b>Cálcio:</b> {lastItemSelected.calcio}mg
                            </div>
                        }
                        {lastItemSelected.cistina != "ND" &&
                            <div className="consultar__modal">
                                <b>Cistina:</b> {lastItemSelected.cistina}mg
                            </div>
                        }
                        {lastItemSelected.fenilanina != "ND" &&
                            <div className="consultar__modal">
                                <b>Fenilanina:</b> {lastItemSelected.fenilanina}mg
                            </div>
                        }
                        {lastItemSelected.fibras != "ND" &&
                            <div className="consultar__modal">
                                <b>Fibras:</b> {lastItemSelected.fibras}g
                            </div>
                        }
                        {lastItemSelected.isoleucina != "ND" &&
                            <div className="consultar__modal">
                                <b>Isoleucina:</b> {lastItemSelected.isoleucina}mg
                            </div>
                        }
                        {lastItemSelected.leucina != "ND" &&
                            <div className="consultar__modal">
                                <b>Leucina:</b> {lastItemSelected.leucina}mg
                            </div>
                        }
                        {lastItemSelected.lisina != "ND" &&
                            <div className="consultar__modal">
                                <b>Lisina:</b> {lastItemSelected.lisina}mg
                            </div>
                        }
                        {lastItemSelected.metionina != "ND" &&
                            <div className="consultar__modal">
                                <b>Metionina:</b> {lastItemSelected.metionina}mg
                            </div>
                        }
                        {lastItemSelected.tirosina != "ND" &&
                            <div className="consultar__modal">
                                <b>Tirosina:</b> {lastItemSelected.tirosina}mg
                            </div>
                        }
                        {lastItemSelected.treonina != "ND" &&
                            <div className="consultar__modal">
                                <b>Treonina:</b> {lastItemSelected.treonina}mg
                            </div>
                        }
                        {lastItemSelected.valina != "ND" &&
                            <div className="consultar__modal">
                                <b>Valina:</b> {lastItemSelected.valina}mg
                            </div>
                        }
                        {lastItemSelected.vitb12 != "ND" &&
                            <div className="consultar__modal">
                                <b>Vitamina b12:</b> {lastItemSelected.vitb12}mcg
                            </div>
                        }
                    </div>
                    {
                        (day || recipeId) &&
                        <div className='consultar__inputModal' style={{ marginTop: 20 }}>
                            <div style={{ fontSize: 10, color: 'red' }}>preencha um dos campos*</div>
                            <TextField
                                id="input-with-sx"
                                fullWidth
                                type="number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                label="Quantidade Consumida (g)"
                                onChange={inputHandlerModal}
                                variant="standard"
                            />
                            {/* <div style={{ fontSize: 10, color: 'red' }}>campo obrigatório*</div> */}
                            {
                                checkHasMedidaCaseira(lastItemSelected) &&
                                <div style={{ marginTop: 10 }}>
                                    <FormControl variant="standard" sx={{ m: 0, minWidth: 140 }}>
                                        <InputLabel id="demo-simple-select-standard-label">Medida Caseira</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={medidaCaseira}
                                            onChange={handleChange}
                                            label="Medida Caseira"
                                        >
                                            <MenuItem value={lastItemSelected.medidacaseira}>
                                                <em>{lastItemSelected.medidacaseira}</em>
                                            </MenuItem>
                                            <MenuItem value={lastItemSelected.medidacaseira2}>
                                                <em>{lastItemSelected.medidacaseira2}</em>
                                            </MenuItem>
                                            <MenuItem value={lastItemSelected.medidacaseira3}>
                                                <em>{lastItemSelected.medidacaseira3}</em>
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            }

                            {
                                medidaCaseira != "" &&
                                <TextField
                                    id="input-with-sx"
                                    fullWidth
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    style={{ marginTop: 10 }}
                                    label={"Quantas medidas caseiras"}
                                    onChange={inputHandlerMedidaCaseira}
                                    variant="standard"
                                />
                            }

                            <div className='consultar__cardSearch' onClick={() => registrarQuantidade(lastItemSelected, inputTextModal, quantidademedida)}>
                                Concluir
                            </div>
                        </div>
                    }
                </Box>
            </Modal>
            <Modal
                open={openModalDoubt}
                onClose={handleCloseDoubt}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <p>Os alimentos foram classificados em 3 grupos de acordo com seu teor de proteína por 100g: </p>
                    <p> <b>Baixo teor proteico (verde): </b> Alimentos com ≤0,5 g de proteína por 100g de alimento. Exceções: gorduras/óleos e temperos, pois independentemente do teor protéico são utilizados em pequena quantidade</p>
                    <p> <b> Moderado teor proteico (amarelo): </b>alimentos contendo 0,6 a 1,2 g de proteína por 100g de alimento</p>
                    <p><b>Alto teor proteico (vermelho):</b> alimentos contendo {'>'}1,2 g de proteína por 100g de alimento</p>
                    <p>'Esta classificação é meramente informativa e não substitui a orientação do seu nutricionista ou médico. Em caso de dúvidas, entre em contato com sua equipe de saúde'</p>
                </Box>
            </Modal>
        </div>
    )
}

export default ConsultarAlimentosDesc
